<template>
    <b-overlay :show="loading">
        <b-row class="justify-content-center">
            <b-col sm="12" md="11">
                <form-tanggal @submit="submit"></form-tanggal>
                <b-card v-if="journals">
                    <div class="d-flex justify-content-end mb-2">
                        <b-dropdown
                            variant="outline-primary"
                            text="Download"
                            right
                            :disabled="!journals"
                        >
                            <b-dropdown-item href="#" @click.prevent="download('pdf')">
                                Export ke PDF
                            </b-dropdown-item>
                            <b-dropdown-item href="#" @click.prevent="download('excel')">
                                Export ke Excel
                            </b-dropdown-item>
                        </b-dropdown>
                    </div>
                    <b-table small :fields="fields" :items="journals" responsive>
                        <template #cell(order)="{index}">
                            {{ ++index }}
                        </template>
                        <template #cell(tanggal)="{ item }">
              {{humanDate(item.tanggal)}}
            </template>
                        <template #cell(nomor)="{item}">
                            <span v-if="item.akun">
                                {{ item.akun.nomor }}
                            </span>
                            <i class="text-danger" v-else>
                                Nomor akun tidak ditemukan
                            </i>
                        </template>
                        <template #cell(akun)="{item}">
                            <span v-if="item.akun">
                                {{ item.akun.nama }}
                            </span>
                            <i class="text-danger" v-else>
                                Akun tidak ditemukan
                            </i>
                        </template>
                        <template #cell(debit)="{item}">
                            <strong>Rp {{ formatRupiah(item.debit) }}</strong>
                        </template>
                        <template #cell(kredit)="{item}">
                            <strong>Rp {{ formatRupiah(item.kredit) }}</strong>
                        </template>
                        <template #cell(total)="{item}">
                            <strong>Rp {{ formatRupiah(item.debit - item.kredit) }}</strong>
                        </template>
                    </b-table>
                </b-card>
                <section v-else class="alert alert-danger p-1">
                    Harap pilih tanggal awal dan tanggal akhir untuk melihat hasil
                </section>
            </b-col>
        </b-row>
    </b-overlay>
</template>
<script>
import {
  BTable, BOverlay, BRow, BCol, BCard, BDropdown, BDropdownItem,
} from 'bootstrap-vue'
import FormTanggal from './components/FormTanggal'
import service from '@/services'

export default {
  components: {
    FormTanggal,
    BTable,
    BOverlay,
    BRow,
    BCol,
    BCard,
    BDropdown,
    BDropdownItem,
  },
  computed: {
    journals() {
      return this.$store.state.laporan.journals
    },
  },
  data: () => ({
    loading: false,
    form: {
      tgl_awal: null,
      tgl_akhir: null,
    },
    fields: [
      { key: 'order', label: '#' },
      { key: 'tanggal', label: 'Tanggal' },
      { key: 'nomor', label: 'Nomor' },
      { key: 'akun', label: 'Akun' },
      { key: 'debit', label: 'Debit' },
      { key: 'kredit', label: 'Kredit' },
      { key: 'total', label: 'Total' },
    ],
  }),
  methods: {
    parseFilename(disposition, fallback) {
      if (!disposition) return fallback
      const utfMatch = disposition.match(/filename\*=UTF-8''([^;]+)/i)
      if (utfMatch && utfMatch[1]) {
        try {
          return decodeURIComponent(utfMatch[1])
        } catch (e) {
          return utfMatch[1]
        }
      }
      const match = disposition.match(/filename="?([^";]+)"?/i)
      return match && match[1] ? match[1] : fallback
    },
    openBlob(blob, filename, typeExport) {
      const url = URL.createObjectURL(blob)
      if (typeExport === 'excel') {
        const link = document.createElement('a')
        link.href = url
        link.download = filename
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        setTimeout(() => URL.revokeObjectURL(url), 1000)
        return
      }
      window.open(url)
      setTimeout(() => URL.revokeObjectURL(url), 60000)
    },
    async download(typeExport) {
      if (!this.journals) {
        this.displayError({
          message: 'Harap klik lihat laporan terlebih dahulu sebelum download!',
        })
        return false
      }
      if (!this.form.tgl_awal || !this.form.tgl_akhir) {
        this.displayError({
          message: 'Harap isi tanggal awal dan akhir!',
        })
        return false
      }

      try {
        this.loading = true
        const config = {
          method: 'get',
          url: this.$route.meta.api || '/cetak-jurnal',
          params: {
            tgl_awal: this.form.tgl_awal,
            tgl_akhir: this.form.tgl_akhir,
            type_export: typeExport,
          },
          headers: {
            Authorization: `${localStorage.tokenType} ${localStorage.token}`,
          },
          responseType: 'blob',
        }
        const response = await service.sendRequest(config)
        this.loading = false
        const fallback = typeExport === 'pdf'
          ? 'Laporan Jurnal.pdf'
          : 'Laporan Jurnal.xlsx'
        const filename = this.parseFilename(
          response.headers && (response.headers['content-disposition'] || response.headers['Content-Disposition']),
          fallback,
        )
        this.openBlob(response.data, filename, typeExport)
      } catch (e) {
        this.loading = false
        if (e.response && e.response.data instanceof Blob) {
          try {
            const text = await e.response.data.text()
            this.displayError(JSON.parse(text))
            return false
          } catch (parseErr) {
            this.displayError(e)
            return false
          }
        }
        this.displayError(e)
        return false
      }
    },
    async submit({ tgl_awal, tgl_akhir }) {
      try {
        this.loading = true
        this.form.tgl_awal = tgl_awal
        this.form.tgl_akhir = tgl_akhir
        await this.$store.dispatch('laporan/getJournal', this.form)
        this.loading = false
      } catch (e) {
        this.loading = false
        this.displayError(e)
        return false
      }
    },
  },
}
</script>
